import _ from "lodash";
import Clipboard from "clipboard";
import html2canvas from "html2canvas";
import { needJoin } from "@/config/apiDomain";
import { imgDomain } from "@/data/pubilc";
// import { showMessageBoxByType } from "@/components/content/MessageBox/messageBox";
import { isAppWebView, isMiniWechatWebView } from "./app/common";
import { ElMessage } from "element-plus";

const rand = (num: number) => {
  const min = 10 ** (num - 1);
  const max = 10 ** num - 1;
  const result = Math.floor(Math.random() * (max - min)) + min;
  return result;
};

const getRandomSeed = () => {
  const result = rand(4) + new Date().getTime().toString().slice(-9);
  return result;
};

const sleep = (delay: number) => {
  return new Promise((resolve) => setTimeout(resolve, delay));
};

const getJsonContent = (str: string, options?: any) => {
  try {
    const path = JSON.parse(str);
    return path;
  } catch {
    return options?.result || null;
  }
};

const getImgPath = (str: string) => {
  try {
    const path = JSON.parse(str)[0];
    return path;
  } catch {
    if (["", "null", null, undefined].includes(str)) return null;
    return str;
  }
};

const getImgPathList = (str: string) => {
  try {
    const path = JSON.parse(str);
    return path;
  } catch {
    return [];
  }
};

const isFourImg = (item: any) => {
  try {
    const pathList = JSON.parse(item.path);
    if (pathList.length === 1 && item.count === 4) {
      return true;
    } else return false;
  } catch {
    return false;
  }
};

const jParse = (str: string, isObj?: boolean) => {
  try {
    const json = JSON.parse(str);
    return json;
  } catch {
    return isObj ? {} : [];
  }
};

// 获取当前时间格式
const formatTime = (type: number) => {
  const date = new Date(new Date().getTime());
  const YY = date.getFullYear() + "-";
  const MM =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  const DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  const hh =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  const mm =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  const ss =
    ":" +
    (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
  if (type == 1) {
    return YY + MM + DD;
  } else if (type == 2) {
    return YY + MM + DD + " " + hh + mm;
  } else {
    return YY + MM + DD + " " + hh + mm + ss;
  }
};

const getFormatTime = (time: any, options?: any) => {
  const t = new Date(time) || new Date();
  const tf = function (i: number) {
    return (i < 10 ? "0" : "") + i;
  };
  const type = options?.type || 0;
  const formatObj = {
    0: "yyyy-MM-dd HH:mm:ss",
    1: "yyyy-MM-dd",
    2: "yyyy-MM-dd HH:mm",
  };
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return formatObj[type]
    .replace(/-/g, options?.connect || "-")
    .replace(/yyyy|MM|dd|HH|mm|ss/g, (a: string) => {
      switch (a) {
        case "yyyy":
          return tf(t.getFullYear());
        case "MM":
          return tf(t.getMonth() + 1);
        case "dd":
          return tf(t.getDate());
        case "HH":
          return tf(t.getHours());
        case "mm":
          return tf(t.getMinutes());
        case "ss":
          return tf(t.getSeconds());
      }
    });
};

const base64ToFile = (base64: string) => {
  const arr: any = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  const time = new Date().getTime();
  const fileName = `base64ToFile-${time}.jpg`;
  return new File([u8arr], fileName, {
    type: mime,
  });
};

const base64ToBlob = (base64: string) => {
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

const blobToFile = (blob: any) => {
  const time = new Date().getTime();
  const fileName = `blobToFile-${time}.jpg`;

  return new File([blob], fileName, {
    type: "image/jpeg",
  });
};

const pathToBase64 = (path: string) => {
  return new Promise((resolve) => {
    // 创建一个临时canvas元素
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // 加载图片
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = path;

    // 图片加载完成后进行切割
    image.onload = async () => {
      // 设置canvas的宽高为图片的四等份大小
      const w = image.width;
      const h = image.height;
      canvas.width = w;
      canvas.height = h;
      if (!ctx) return;
      ctx.drawImage(image, 0, 0, w, h, 0, 0, w, h); // 第一个切割部分
      const newPath = canvas.toDataURL();
      resolve(newPath);
    };
  });
};

//文件大小转换
function renderByteSize(
  fileSize: number
  // type: "KB" | "MB" | "GB" | "TB" | "PB" | "EB" | "ZB" | "YB"
) {
  if (!fileSize) {
    return {
      renderStr: `0`,
      size: 0,
      unit: "",
    };
  }
  const unitArr = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  let index = 0;
  const srcsize = parseFloat(`${fileSize}`);
  index = Math.floor(Math.log(srcsize) / Math.log(1024));
  if (index < 0) {
    index = 0;
  } else if (index > unitArr.length - 1) {
    index = unitArr.length - 1;
  }
  let size = srcsize / Math.pow(1024, index);
  size = +size.toFixed(2); //保留的小数位数
  return {
    renderStr: `${size}${unitArr[index]}`,
    size,
    unit: unitArr[index],
  };
}

async function copyToClipboard(text: string) {
  if (isAppWebView()) {
    return webUni.postMessage({
      data: {
        action: "copyText",
        params: {
          text: text,
        },
      },
    });
  }
  if (!navigator.clipboard) {
    const textarea = document.createElement("textarea");
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    ElMessage.success("复制成功");
    return true;
  }
  try {
    await navigator.clipboard.writeText(text);
    ElMessage.success("复制成功");
    return true;
  } catch (error) {
    return false;
  }
}

const copyByClipboard = (
  copyText: string,
  classSelector: string,
  text?: string
) => {
  if (isAppWebView()) {
    return webUni.postMessage({
      data: {
        action: "copyText",
        params: {
          text: copyText,
        },
      },
    });
  }
  const clipboard = new Clipboard(`${classSelector}`, {
    text: function () {
      return copyText;
    },
  });
  clipboard.on("success", () => {
    ElMessage.success(text || "复制成功");
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    ElMessage.error("复制失败");
    clipboard.destroy();
  });
};

const downloadImage = async (imgUrl: string) => {
  const a = document.createElement("a");
  const isBase64 = imgUrl.startsWith("data:image");
  const base64 = isBase64 ? imgUrl! : ((await pathToBase64(imgUrl!)) as string);
  if (isAppWebView()) {
    webUni.postMessage({
      data: {
        action: "appSaveImgFile",
        params: {
          base64,
          downloadName: `${Math.random().toString(36).slice(-8)}.png`,
        }, // 向app发送信息
      },
    });
    return;
  }
  const path = URL.createObjectURL(base64ToBlob(base64));
  const name = `${Math.random().toString(36).slice(-8)}.png`;
  a.href = path;
  a.download = name;
  a.click();
  if (isMiniWechatWebView()) {
    ElMessage.success("请长按保存图片");
    return;
  }
  ElMessage.success("已为您下载图片，如下载失败，请右键保存或长按保存图片");
};

function imgUrlToFile(url: string, limit?: number) {
  // 加载图片
  const image = new Image();
  image.setAttribute("crossOrigin", "anonymous");
  image.src = url;
  const canvas = document.createElement("canvas");
  const ctx: any = canvas.getContext("2d");
  return new Promise((resolve) => {
    image.onload = async () => {
      const size = limit || 1024;
      const long = image.width > image.height ? image.width : image.height;
      let scale = 1;
      if (long > size) {
        scale = size / long;
      }
      const w = image.width * scale;
      const h = image.height * scale;
      canvas.width = w;
      canvas.height = h;
      ctx.drawImage(image, 0, 0, w, h);
      const canvasPath = canvas.toDataURL();
      const file = base64ToFile(canvasPath);
      resolve(file);
    };
    image.onerror = () => {
      resolve(null);
    };
  });
}

function html2canvasGetBase64Image(querySelector: string) {
  const dom = document.querySelector(querySelector)! as HTMLElement; // 获取dom元素
  if (!dom) return;
  // var dom = document.querySelector(`#${id}`);
  return new Promise((resolve, reject) => {
    html2canvas(dom, {
      useCORS: true, //支持跨域，但好像没什么用
      width: dom.clientWidth, //dom 原始宽度
      height: dom.clientHeight,
      scrollY: 0, // html2canvas默认绘制视图内的页面，需要把scrollY，scrollX设置为0
      scrollX: 0,
      // async: false, // 是否异步解析和呈现元素
      // 以下字段必填
      // background: "#ffffff", // 一定要添加背景颜色，否则出来的图片，背景全部都是透明的
    })
      .then((canvas: any) => {
        // 将生产的canvas转为base64图片
        const base64: string = canvas.toDataURL("image/png");
        resolve(base64);
      })
      .catch((err: any) => {
        reject(err);
      });
  });
}

const addQueryToUrl = function (param: any, url: string) {
  // 判断是否有问号
  if (url.indexOf("?") !== -1) {
    url += "&";
  } else {
    url += "?";
  }
  for (const key in param) {
    if (["", null, undefined].includes(param[key])) continue;
    // 获取 ？ 后的参数，如果有重复的，去除
    const paramsUrl = url.split("?")[1];
    if (paramsUrl.indexOf(key) > -1) continue;

    url = url + `${key}=${param[key]}&`;
  }
  return url.slice(0, -1);
};

const addImageCdnDomain = (url?: string) => {
  if (!url) return "";
  const needToJoin = needJoin.some((item: string) => url.indexOf(item) === 0);
  return (needToJoin ? imgDomain : "") + url;
};

/**
 * 将base64转换为blob
 * @param url 图片地址
 * @param plot 图片比例，宽/高
 * @param options
 * @returns
 */
const plotImage = (url: string, plot: number, options?: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const ctx: any = canvas.getContext("2d");
      const config = {
        width: image.width,
        height: image.height,
      };
      const imgPlot = image.width / image.height;
      if (imgPlot > plot) {
        config.height = image.width / plot;
      } else if (imgPlot < plot) {
        config.width = image.height * plot;
      }
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, image.width, image.height);
      ctx.drawImage(image, 0, 0);
      const limitSize = options?.limit || 2048;
      const offect = {
        t: parseInt(((config.height - image.height) / 2).toString()),
        l: parseInt(((config.width - image.width) / 2).toString()),
      };
      if (limitSize < Math.max(config.width, config.height)) {
        const scale = limitSize / Math.max(config.width, config.height);
        offect.t = parseInt((offect.t * scale).toString());
        offect.l = parseInt((offect.l * scale).toString());
      }
      ctx.beginPath();
      const base64Path = canvas.toDataURL();
      const res: any = await compressImage(base64Path, options);
      res.offect = offect;
      resolve(res);
    };
    image.onerror = (e: any) => {
      reject(e);
    };
  });
};

const compressImage = (url: string, data?: any) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx: any = canvas.getContext("2d");
      const short = image.width > image.height ? image.width : image.height;
      let scale = 1;
      const limitSize = data?.limit || 2048;
      if (short > limitSize) {
        scale = limitSize / short;
      }
      const w = image.width * scale;
      const h = image.height * scale;
      canvas.width = w;
      canvas.height = h;
      ctx.drawImage(image, 0, 0, w, h);
      ctx.beginPath();
      ctx.arc(rand(w), rand(h), 1, 0, 2 * Math.PI);
      ctx.fillStyle = "#00000005";
      ctx.fill();
      const base64Path =
        data?.type === "jpg"
          ? canvas.toDataURL("image/jpeg", 1.0)
          : canvas.toDataURL();
      const blobPath = URL.createObjectURL(base64ToBlob(base64Path));
      const file = base64ToFile(base64Path);
      resolve({
        base64Path,
        blobPath: (scale === 1 && data?.blobPath) || blobPath,
        file: ((data?.unCompress || scale === 1) && data?.file) || file,
        width: image.width,
        height: image.height,
      });
    };
    image.onerror = (e: any) => {
      reject(e);
    };
  });
};

const magnifyImage = (url: string, width: number, height: number) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx: any = canvas.getContext("2d");
      const w = width;
      const h = height;
      canvas.width = w;
      canvas.height = h;
      ctx.drawImage(image, 0, 0, w, h);
      const base64Path = canvas.toDataURL();
      const blobPath = URL.createObjectURL(base64ToBlob(base64Path));
      const file = base64ToFile(base64Path);
      resolve({ base64Path, blobPath, file });
    };
    image.onerror = (e: any) => {
      reject(e);
    };
  });
};

const scaleMagnifyImage = (url: string, size?: number) => {
  const scaleSize = size || 512;
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx: any = canvas.getContext("2d");
      const w = image.width;
      const h = image.height;
      const imageSize = w > h ? w : h;
      if (imageSize < scaleSize) {
        const scale = scaleSize / imageSize;
        canvas.width = w * scale;
        canvas.height = h * scale;
      } else {
        canvas.width = w;
        canvas.height = h;
      }
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      const base64Path = canvas.toDataURL();
      const blobPath = URL.createObjectURL(base64ToBlob(base64Path));
      const file = base64ToFile(base64Path);
      resolve({ base64Path, blobPath, file });
    };
    image.onerror = (e: any) => {
      reject(e);
    };
  });
};

const judgeError = (e: any) => {
  if (e.unShow) return;
  if (e.code === 10001) {
    // showMessageBoxByType("vipNoPointsRemind");
    return;
  } else if (e.code === 10002) {
    // showMessageBoxByType("trialLacking");
    return;
  } else if (e.code === 10003) {
    // showMessageBoxByType("taskBlockUp");
    return;
  }
  ElMessage.error(e.msg);
};

const getRandom = (a: number, b: number) => {
  let max = a;
  let min = b;
  if (a < b) {
    max = b;
    min = a;
  }
  return parseInt((Math.random() * (max - min)).toString()) + min;
};
const randomNum = (
  num: boolean,
  maxA: boolean,
  minlA: boolean,
  fqy: number
) => {
  const arr: number[] = [];
  const arr1: number[] = [];
  const arr2: number[] = [];
  if (num) {
    for (let m = 0; m <= 9; m++) {
      arr.push(m);
    }
  }
  if (maxA) {
    for (let m = 65; m <= 90; m++) {
      arr1.push(m);
    }
  }
  if (minlA) {
    for (let m = 97; m <= 122; m++) {
      arr2.push(m);
    }
  }
  const mergeArr = arr.concat(arr1);
  const mergeArr1 = mergeArr.concat(arr2);
  const _length = mergeArr1.length;
  let text = "";
  for (let m = 0; m < fqy; m++) {
    let text1: number | string = "";
    const random = getRandom(0, _length);
    if (mergeArr1[random] <= 9) {
      text1 = mergeArr1[random];
    } else if (mergeArr1[random] > 9) {
      text1 = String.fromCharCode(mergeArr1[random]);
    }
    text += text1;
  }
  return text;
};
const exceedLimitInput = (input: string, maxChars = 2000) => {
  // 用于匹配中文字符的正则表达式
  const chineseCharRegex = /[\u4e00-\u9fa5]/g;
  const chineseChars = input.match(chineseCharRegex) || [];
  const chineseCharCount = chineseChars.length;

  // 用于匹配英文单词的正则表达式 (字母和数字组成的单词)
  const englishWordRegex = /\b[a-zA-Z0-9]+\b/g;
  const englishWords = input.match(englishWordRegex) || [];
  const englishWordCount = englishWords.length;

  const count = chineseCharCount + englishWordCount;
  return count > maxChars;
};

const getEnvironment = () => {
  // #ifdef H5
  let result = "";
  const ng = navigator.userAgent;
  const detectDeviceType =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile|IEMobile|Opera Mini/i.test(
      ng
    )
      ? false
      : true;
  const ua = window ? window.navigator.userAgent.toLowerCase() : "";
  if (
    ua.match(/MicroMessenger/i)?.[0] == "micromessenger" &&
    ua.match(/wxwork/i)?.[0] != "wxwork"
  ) {
    // 是微信客户端
    result = detectDeviceType ? "pc-wechat" : "phone-wechat";
  } else {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (ng.indexOf("csdgpt") != -1 || window.win_message !== undefined) {
      result = "desktop-app";
    } else {
      result = detectDeviceType ? "pc-web" : "phone-web";
    }
  }

  return result;
  // #endif
};
const getImageInfo = (url: string) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = url;
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      reject(new Error("Failed to load image"));
    };
  });
};

export const isFontAvailable = (fontName: string) => {
  if (typeof fontName !== "string") return false;

  const arial = "Arial";
  if (fontName.toLowerCase() === arial.toLowerCase()) return true;

  const size = 100;
  const width = 100;
  const height = 100;
  const str = "a";

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d", { willReadFrequently: true });

  if (!ctx) return false;

  canvas.width = width;
  canvas.height = height;
  ctx.textAlign = "center";
  ctx.fillStyle = "black";
  ctx.textBaseline = "middle";

  const getDotArray = (_fontFamily: string) => {
    ctx.clearRect(0, 0, width, height);
    ctx.font = `${size}px ${_fontFamily}, ${arial}`;
    ctx.fillText(str, width / 2, height / 2);
    const imageData = ctx.getImageData(0, 0, width, height).data;
    return [].slice.call(imageData).filter((item) => item !== 0);
  };

  return getDotArray(arial).join("") !== getDotArray(fontName).join("");
};

export {
  getEnvironment,
  rand,
  getRandomSeed,
  downloadImage,
  copyToClipboard,
  copyByClipboard,
  sleep,
  getJsonContent,
  getImgPath,
  getImgPathList,
  isFourImg,
  jParse,
  formatTime,
  getFormatTime,
  pathToBase64,
  base64ToFile,
  base64ToBlob,
  blobToFile,
  renderByteSize,
  html2canvasGetBase64Image,
  addQueryToUrl,
  imgUrlToFile,
  addImageCdnDomain,
  compressImage,
  magnifyImage,
  scaleMagnifyImage,
  judgeError,
  randomNum,
  exceedLimitInput,
  plotImage,
  getRandom,
  getImageInfo,
};
